/* eslint-disable */
import { image } from '~/js/utils/image';

/**
 * Build Product HTML
 * @param {Object} product
 * @param {number} idx
 */
export function buildProduct(product, idx) {
  const imageUrlList = product.variant?.data[`${window.Shopify.shop}_ImageUrls`]?.value.$values || [];
  
  const extraImage = () => {
    if ( imageUrlList.length > 1 ) {
      const imgObject = {
        src: imageUrlList[1],
        alt: '',
        height: 400,
        width: 400
      }

      return image(imgObject, 'image image-second opacity-0 group-hover:opacity-100')
    } else return ''
  }

  const images = () => {
    if ( imageUrlList.length ) {
      let imgClass = 'image transition-opacity';
      
      if ( imageUrlList.length > 1 ) {
        imgClass = imgClass + ' lg:group-hover:opacity-0';
      }

      const imgObject = {
        src: imageUrlList[0],
        alt: '',
        height: 400,
        width: 400
      }

      return `
        ${ image(imgObject, imgClass) }
        ${ extraImage() }
      `;
    } else {
      return `<img class="border !h-full border-basics-medium-grey" src="https://cdn.shopify.com/s/files/1/0567/6643/1398/files/no-image.jpg?v=1623402346" alt="placeholder"/>`;
    }
  }

  const prices = () => {
    const price = product.salesPrice * 100;
    const compareAtPrice = product.listPrice * 100;

    const priceHtml = `
      <span data-update="stl-price" class="font-semibold text-sm ${price < compareAtPrice ? 'text-primary': ''}">
        ${ Shopify.formatMoney(price, theme.moneyFormat) }
      </span>
    `

    const compareAtPriceHtml = `
      <del data-update="stl-old-price" class="ml-4 text-warm-gray-400 text-sm font-normal">
        ${ Shopify.formatMoney(compareAtPrice, theme.moneyFormat) }
      </del>
    `;

    if (compareAtPrice > price) {
      return `
        ${priceHtml}
        ${compareAtPriceHtml}
      `
    } else {
      return priceHtml;
    }
  }

  const buildPills = () => {
    let showSaleLabel = true;

    const buildSalePill = () => {
      showSaleLabel = window.theme?.pfs?.showSaleLabel == 'true' || false;

      const price = product.salesPrice * 100;
      const compareAtPrice = product.listPrice * 100;

      if ( showSaleLabel && price < compareAtPrice ) {
        const diff = compareAtPrice - price;
        const discount = `${ Math.round((((diff / 100) * 100) / compareAtPrice) * 100) }%`;
        const text = window.theme.pfs.saleLabelText.replace('{{ discount }}', discount);

        return `
          <span class="label pt-1 pb-2 bg-sand-300 font-heading font-semibold">
            ${ text }
          </span>
        `;
      } else return ``;
    };

    var html = '<div class="item-pills ml-4">';

    if ( showSaleLabel ) {
      html += buildSalePill();
    }

    html += '</div>';
    return html;
  };

  const vendor = () => {
    if (!product.data?.Vendor) return '';

    return `
    <div class="flex items-center gap-1">
      <p class="text-sand-800 font-heading font-semibold text-sm leading-none">
        ${ product.data.Vendor.value }
      </p>
      ${ buildDiscountPeriod({ returnIcon: true }) }
    </div>
    `
  }

  const handle = () => {
    return product.data[`${window.Shopify.shop}_ShopifyHandle`].value;
  }

  const buildDiscountPeriod = ({ returnIcon = false }) => {
    let text = '';
    let icon = '';

    const formatDate = (date) => {
      return new Intl.DateTimeFormat(`${ Shopify.locale.split('-')[0] }-${ Shopify.country }`, {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      }).format(date)
    }

    theme.discountPeriods.forEach(period => {

      period.tags.forEach(tag => {
        if (product.data.Tags.value.$values.find(t => t == tag)) {
          const start = new Date(period.start_date);
          const end = new Date(period.end_date);

          if (end > new Date()) {
            text = theme.strings.discountPeriod
              .replace('start', formatDate(start))
              .replace('end', formatDate(end))

            if (returnIcon && period.icon) {
              icon = `<img class="w-auto h-8" src="${ period.icon }" alt="${ period.name }"/>`;
            }
          }
        }
      })
    });

    if (returnIcon) {
      if (!icon) {
        return '';
      }
      return icon;
    } else {

      return text ? `<div class="text-xs mt-4">${ text }</div>` : '';
    }
  }

  const buildCard = () => `
    <div class="group search-product-item flex items-center relative w-full py-6 ${idx === 0 || idx === 1 && window.matchMedia('(min-width: 768px)').matches ? '' : 'border-t'} last:border-b-0 border-warm-gray-200 transition-colors duration-200 md:w-[48%]">
      
      <div class="w-40 mr-6 flex-shrink-0">
        <div class="aspect-ratio aspect-ratio--1/1">
          ${images()}
        </div>
      </div>

      <div class="item-body" data-id="${product.productId}">
        ${vendor()}

        <p class="mb-3">
          <span class="text-warm-gray-500 font-heading text-sm line-clamp-1 no-underline">
            ${product.displayName}
          </span>
        </p>

        <div class="flex flex-wrap font-heading">
          ${prices()}
          ${buildPills()}
        </div>
        
        ${product.promoted ? `<div class="flex items-center gap-1 text-warm-gray-400">
          <span class="font-heading text-[10px] lg:text-10 font-semibold">${theme.strings.promotedContent.label}</span>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 15" class="size-[1.4rem]" fill="none">
            <line x1="7" y1="5.2" x2="7" y2="7.5" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" stroke="currentColor"/>
            <line x1="7" y1="9.8" x2="7" y2="9.8" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" stroke="currentColor"/>
            <circle cx="7" cy="7.5" r="5.8" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" stroke="currentColor"/>
          </svg>
        </div>` : ''}
      </div>
      
      <a class="absolute top-0 left-0 w-full h-full z-10" href="${Shopify.routes.root}products/${ handle() }"></a>
    </div>
  `;

  return buildCard();
}

/**
* Builds category links
* @param {Array} products
*/
export default (products) => {
  let html = '';

  if (products.length) {
    products.forEach((product, idx) => {
      let item = buildProduct(product, idx);
      html += item;
    });

    document.dispatchEvent(new Event('app:remount'));
  }

  return html;
}
